export default String.raw`
.comparison {
    &__dialog {
        .dialog {
            &__content {
                padding: 24px 16px 0 16px;
                gap: 24px;
            }
        
            &__title {
                @include h4-headline;
            }
        
            &__actions {
                justify-content: center;
                flex-direction: column-reverse;
                align-items: center;
                padding: 24px 16px;
            }
        }

        &-top-info {
            flex-direction: column-reverse;
            align-items: flex-start;
    
            >svg {
                display: none;
            }
    
            &-group {
                display: flex;
                flex-direction: column;
                gap: 8px;
            }
    
            .comparison__items {
                margin-left: 0;
            }
        }
    }
    
    &__list-item-image {
        width: 60px;
        height: 60px;
        min-width: 60px;
        min-height: 60px;
    }
}

`